// extracted by mini-css-extract-plugin
module.exports = {"block":"MainSlider_block__xs6ki","broadcastStatus":"MainSlider_broadcastStatus__pAZYk","inner":"MainSlider_inner__zPECm"};